import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./FAQ.css";

const faqItems = [
  {
    q: "What is the difference between a landing page and a full website?",
    a: "A landing page focuses on conversions and a single goal (sign-ups, sales, etc.), while a full website covers multiple pages like Home, About, Services, and Contact. Landing pages are faster, simpler, and built to improve performance of ads or marketing campaigns.",
  },
  {
    q: "How long does it take to build a modern website?",
    a: "A standard website usually takes 7–14 days depending on features, revisions, branding, and content. More complex sites with custom integrations may take 3–6 weeks.",
  },
  {
    q: "Can you redesign my existing website to make it more modern?",
    a: "Absolutely. We can rebuild or refresh your current website with responsive design, better UI/UX, improved performance, and optimized content without changing your existing domain.",
  },
  {
    q: "Will my website be mobile-friendly?",
    a: "Yes. All websites we build are fully responsive and optimized for phones, tablets, and desktops. Over 70% of users browse on mobile — so mobile optimization is a priority.",
  },
  {
    q: "Do you provide hosting and domain setup?",
    a: "Yes. We guide you through choosing the best hosting provider and help you set up domains, emails, and DNS. If needed, we handle the entire setup for you.",
  },
  {
    q: "Will my website be SEO optimized?",
    a: "Yes. Every site includes essential SEO features like meta tags, speed optimization, structured content, and indexing setup so your website ranks better on Google.",
  },
  {
    q: "Can I update my website on my own after it's built?",
    a: "Yes. We build websites on platforms that allow easy editing. You can change text, images, products, and sections without touching code. We also offer training if needed.",
  },
  {
    q: "Do you provide ongoing support and maintenance?",
    a: "Yes. We offer monthly maintenance plans which include updates, security checks, backups, bug fixes, and feature improvements.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section style={{ padding: "80px 0" }}>
      <Container>
        {/* Title */}
        <div className="text-center mb-5">
          <small
            className="badge bg-light text-dark px-3 py-2"
            style={{ borderRadius: "20px", fontSize: "18px" }}
          >
            FAQs
          </small>

          <h1
            className="fw-bold mb-3"
            style={{
              fontSize: "clamp(2.6rem, 4.8vw, 3.4rem)",
              letterSpacing: "-0.04em",
              color: "#000",
            }}
          >
            Frequently Asked{" "}
            <span style={{ color: "#ff6baf" }}>Questions</span>
          </h1>
        </div>

        {/* Straight (single-column) FAQ list */}
        <div className="faq-list">
          {faqItems.map((item, index) => {
            const active = openIndex === index;

            return (
              <div key={index} className="faq-item">
                <div
                  className="faq-question"
                  onClick={() => toggle(index)}
                >
                  <span>{item.q}</span>
                  <span className="faq-icon">{active ? "−" : "+"}</span>
                </div>

                {active && <p className="faq-answer">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default FAQ;
